module.exports = __webpack_public_path__ + "img/about_me.2c1dca34.png";